import { graphql } from '@/gql'

export const ComplianceReviewHireFragment = graphql(`
  fragment ComplianceReviewHire on Hire {
    id
    number
    activeStatus
    pendingExtension {
      previousEndDate
      newEndDate
    }
    job {
      id
      name
    }
    checklists {
      id
      checkCounts {
        total
        done
        blockingPending
      }
    }
    ...HireCurrentContract
  }
`)
